import type { RefObject } from 'react';
import { useEffect } from 'react';

export const useClickOutside = (refs: RefObject<HTMLElement>[] | RefObject<HTMLElement>, handler: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const refsArray = Array.isArray(refs) ? refs : [refs];
      const clickedOutside = refsArray.every((ref) => {
        return !ref.current?.contains(event.target as Node);
      });

      if (clickedOutside) {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [refs, handler]);
};
